import { useContext } from 'react';
import { createSetIntentType, getIntents } from '../../intent';
import { mergeProperty } from './props';
import { onComponentWillReceiveProps } from './transformProps';
const setDefaultsIntent = createSetIntentType('setDefaults', (decorate)=>(props)=>decorate(props));
export const setDefaults = (props, Context)=>{
    return onComponentWillReceiveProps(()=>{
        const overrides = useContext(Context) || {};
        return [
            setDefaultsIntent({
                ...props,
                ...overrides
            })
        ];
    });
};
export function applyDefaults(props) {
    const overrides = getIntents(setDefaultsIntent, props) || [];
    // flatten overrides into a single object, last call wins
    const defaults = Object.assign({}, ...Array.from(overrides));
    const target = props;
    const keys = Object.keys(defaults);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!(key in props)) {
            mergeProperty(target, key, defaults[key]);
        }
    }
}

//# sourceMappingURL=setDefaults.js.map